import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { ALARM_COUNT } from './url-constants';

type AlarmCountEndpointSpecification = ApiEndpointSpecification;
export const AlarmCountEndpointSpecification: AlarmCountEndpointSpecification = {
    url: ALARM_COUNT,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'AlarmCountRequestParams',
    requestBodySchemaName: 'AlarmCountRequestBody',
    okResponseSchemaName: 'AlarmCountOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeAlarmCount = Helpers.makeApiRequestFn<
    Types.AlarmCountRequestParams,
    Types.AlarmCountRequestBody,
    Types.AlarmCountOkResponse
>(AlarmCountEndpointSpecification);
